import { resolve } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import ApplicationVersion from './ApplicationVersion';
import loadApplicationVersion from './loadApplicationVersion';

export const ActionTypes = {
	request: 'ApplicationUpdate.request',
	receive: 'ApplicationUpdate.receive',
};

export function checkApplicationUpdate(): ThunkAction<Promise<ApplicationVersion>, any> {
	return (dispatch) => {
		const request = loadApplicationVersion();
		dispatch({ type: ActionTypes.request });
		return resolve(request, (version) => dispatch({ type: ActionTypes.receive, version }));
	};
}

export function checkApplicationUpdateEvery(hours: number): ThunkAction<void, any> {
	return (dispatch) => {
		dispatch(checkApplicationUpdate()).catch(() => null);
		dispatch(schedulleApplicationUpdateCheck(hours * 60 * 60 * 1000));
	};
}

function schedulleApplicationUpdateCheck(millisecondsDelay: number): ThunkAction<void, any> {
	return (dispatch) => {
		setInterval(() => dispatch(checkApplicationUpdate()).catch(() => null), millisecondsDelay);
	};
}
